<template>
  <div style="width: 100%; height: 100%;display:flex">
    <div class="mapWrap" >
      <iframe id="mapframe" src="../../../static/EvMap/spacecontrol.html" width="100%" height="100%" style="border: 0px"></iframe>
    </div>

    <div class="openPlan" title="空域使用计划" v-show="!openPlan&& !openleft" @click="handelOpenPlan">
      <img src="../../assets/img/2dmap/pop_close_open.png" alt=""/>
    </div>
    <div class="closePlan" v-if="openPlan" @click="closePlanTime">
      <img src="../../assets/img/2dmap/pop_close_open.png" alt=""/>
    </div>
    <div class="leftPlan" v-show="openPlan">
      <div class="itemTitle">
        <div class="itemTitleText">空域使用计划</div>
      </div>
      <div id="chart" style="width: 100%;height:calc(100% - 82px);overflow: hidden;">
        <div class="timeSlider">
          <el-slider  v-model="sliderValue" :min="0" :max="86399" :step="1" @change="handleChange"
                      :format-tooltip="formatTooltip"></el-slider>
          <p>当前选择的时间: {{ currentTime }}</p>
        </div>
        <div class="timeListWrap">
          <div v-for="item in airSpacePlanData" >
            <timeAxis @update="handelOpenPlan"   :data="item"></timeAxis>
          </div>
        </div>

      </div>
    </div>

    <div id="chooseAirspace" v-show="flyArea">
      <div class="airspaceTitle"><span>空域详情</span></div>
      <div class="close" @click="close()">
        <img src="../../assets/img/2dmap/jiantou_xiashoulong.png" alt=""/>
      </div>
      <el-form
        :model="airSpaceInfo"
        ref="airSpaceInfo"
        label-width="120px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-col v-if="shapeType===1" class="positionSet">
          <el-form-item  label="中心点" prop="center">
            <el-input
              v-model="airSpaceInfo.center"
              type="text"
              disabled
              placeholder="请填写中心点经纬度以逗号隔开"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="shapeType===1" class="positionSet">
          <el-form-item label="半径" prop="radius">
            <el-input
              v-model="airSpaceInfo.radius"
              type="text"
              disabled
              placeholder="请填写半径"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-row class="coordinateRow" v-if="shapeType===0">
          <el-form-item class="coordinate"
                        v-for="(coordinate, index) in airSpaceInfo.airSpaseCoordinateArr"
                        :label="`坐标点 ${index+1}`"
                        :key="coordinate.key"
                        :prop="`airSpaseCoordinateArr.${index}.value`"
          >
            <el-input v-model="coordinate.value" disabled placeholder="经度，纬度以逗号分隔">
            </el-input>
          </el-form-item>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item class="select" label="空域类型" prop="type">
              <el-select v-model="airSpaceInfo.type" placeholder="请选择空域类型">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item class="alarmtime" label="空域名称" prop="name">
              <el-input
                disabled
                v-model="airSpaceInfo.name"
                type="text"
                placeholder="请填写空域名称"
              >
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item class="alarmtime" label=" 底面高度" prop="bottomHeight">
              <el-input
                disabled
                v-model="airSpaceInfo.bottomHeight"
                type="text"
                placeholder="请填写底面高度"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="alarmtime" label="空域高度" prop="height">
              <el-input
                disabled
                v-model="airSpaceInfo.height"
                type="text"
                placeholder="请填写空域高度"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item class="time" label="开始时间" prop="date1">
              <el-date-picker
                disabled
                v-model="airSpaceInfo.date1"
                type="datetime"
                placeholder="请选择时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="time" label="结束时间" prop="date2">
              <el-date-picker
                disabled
                v-model="airSpaceInfo.date2"
                type="datetime"
                placeholder="请选择时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              class="alarmtime"
              label="告警时间(分钟)"
              prop="minute"
            >
              <el-input
                disabled
                v-model="airSpaceInfo.minute"
                type="text"
                placeholder="请填写时间"
              >
                <!-- <template slot="append">分钟</template> -->
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="alarmtime" label="面积(km²)" prop="area">
              <el-input v-model="airSpaceInfo.area" disabled type="text" >
                <!-- <template slot="append">km²</template> -->
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item class="select" label="审批类型" prop="approvingType">
              <el-select v-model="airSpaceInfo.approvingType" placeholder="请选择审批类型">
                <el-option
                  v-for="item in approvingTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="alarmtime" label="审批单位" prop="approvingUnit">
              <el-input
                v-model="airSpaceInfo.approvingUnit"
                type="text"
                placeholder="请填写审批单位"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item class="alarmtime" label="申请单位" prop="institution">
              <el-input
                disabled
                v-model="airSpaceInfo.institution"
                type="text"
                placeholder="请填写申请单位"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="note" label="备注" prop="note">
              <el-input
                disabled
                v-model="airSpaceInfo.note"
                :rows="2"
                type="textarea"
                placeholder="无"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-show="!openPlan&& !openleft" class="heightSliderWrap">
      <span class="spanClass">{{this.value[0]+ "~"+ this.value[1]+ "m" }}</span>
      <el-slider
        class="heightSlider "
        v-model="value"
        vertical
        range
        :min="0"
        :max="3000"
        :step="15"
        @change="handelHeightSlider"
        :marks="marks"
      >
      </el-slider>
    </div>
  </div>
</template>

<script>
import PlanDetail from "../../common/PlanDetail";
import timeAxis from "./time-axis/timeAxis.vue";
import {timestampToTime} from "../../utils/tools";
export default {
  name: "ThreedSpaceControl",
  components: {
    PlanDetail,
    timeAxis
  },
  data() {
    let marks = {}
    const step = 15;
    for (let i = 0; i <= 3000; i += step) {
      if (i === 0 || (i % 150 === 0 && i<901)||(i % 300 === 0 && i>900)) {
        marks[i] = `--- ${i}`;
      } else {
        marks[i] = '-';
      }
    }
    return {
      approvingTypeOptions: [
        {
          value: 0,
          label: "全部"
        },
        {
          value: 1,
          label: "军方"
        },
        {
          value: 2,
          label: "政府"
        },
      ],
      planViewData:{},//飞行概览数据
      planActivity:{},//飞行活动数据
      aircraftData:{detail:[]},//飞行器数据
      taskForm:{},
      clickButton:false,
      searchTaskKeyWord:'',
      taskList:[],
      timeInfo: {
        currentTime: "10:04:06",
        date: "2020-10-20",
        weekday: "星期一"
      },
      chartType: 1,//右侧折线图切换1.运行小时数2.运行架次3.运行里程
      leftTop:null,
      rightCenter:null,
      rightBottom:null,
      rightTop:null,
      rightTopData:[],
      leftTopData:[],
      rightCenterData:[],
      rightBottomData:[],
      bottomClick:'2',
      runTask: [], //执行中计划
      preTask: [], //待执行计划
      doneTask: [], //已执行计划
      realTask:[],//实时事件
      changeRunTask: [], //处理后的计划
      searchDoneTask:'',
      searchRealTask:'',
      searchPreTask:'',
      // 存储被点击的id
      startIds:[],
      changeIds:[],
      downIds:[],
      facilitiesData:{},//地面基础设施数据
      loginUrl:!location.hostname.toString().includes('192.168.205')?'http://220.248.31.148:9601':"http://192.168.205.105:9601",//本地地址
      inspectionHistory:{arr:[]},//巡检历史统计数据
      inspectionWeek:{},//巡检当周统计数据
      inspectionDefect:[],//巡检缺陷史统计数据
      inspectionKey:'e3dea0f5-37f2-4d79-ae58-490af3228069',//巡检key
      openLeft:true,//是否展开左侧计划列表
      ws: null,
      airSpacePlanData:[],
      openPlan: false,
      openleft: false,
      airSpaceInfo: {
        region: "适飞区",
        height: "200m",
        institution: "hjjj",
        name: "1号飞行区",
        date1: "2024-12-19 00:00:00",
        date2: "2024-12-24 00:00:00",
        minute: '56',
        area: "200㎡",
        note: "sdhudh",
        airspacePointArry: '',
        airSpaseCoordinateArr: [{value: ''}],
        center: '',
        radius: '',
        id: null,
      },
      flyArea: false,
      shapeType: 0,//0多边形，1圆
      options: [
        {
          value: "0",
          label: "禁飞区"
        },
        {
          value: "1",
          label: "电子围栏"
        },
        {
          value: "3",
          label: "适飞区"
        },
        {
          value: "4",
          label: "受限区"
        },
        {
          value: "11",
          label: "管制区域"
        }
      ],
      sliderValue: 0,
      currentTime: '00:00:00',
      value: [0, 3000],
      marks: marks,
    };
  },
  watch:{
    runTask(){
      this.changeRunTask = this.runTask.map(v=>({...v,startChecked:false,changeChecked:false,downChecked:false}))
    }
  },
  mounted() {
    let _this= this;
    this.currentTime = this.formatTime(this.sliderValue);
    window.addEventListener("message", function (event){
      let data= event.data;
      if (data.code== 0){
        // 空域协同展开
        _this.openleft = data.data.openleft;
      }
      if (data.code== 100){
        console.log(data.data)
        if (data.data.name.indexOf("机场")>=0){
          return;
        }
        if (data.data.radius!=''){
          _this.shapeType= 1;
        }else {
          _this.shapeType= 0;
        }
        // 空域点击事件
        _this.airSpaceInfo= data.data;
        if (data.data!= {}) {
          _this.flyArea = true;
        }
      }
    }, false);
  },
  beforeDestroy(){
    clearInterval(window.queryTaskTimer)
  },
  methods:{
    // 生成随机字符串
    generateRandomString(length = 10) {
      const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    },
    showPlanDetail(info){
      console.log(info)
      this.taskForm = info
      this.clickButton = true
    },
    updateDialogVisible(newVal){
      this.clickButton = newVal
    },
    closeForm(value){
      this.clickButton = value
    },
    searchClick(v){
      this.queryPlan(v);
    },
    queryPlan() {
      this.getRequest(
        `/uav-task-server/plandto/queryPlanByConditionNoStatus?pagesize=100&keyWord=${this.searchTaskKeyWord}`
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let records = oData.data.list;
          if (records && records.length > 0) {
            // let simpleArray = records.map(item => ({
            //   id: item.id,
            //   planSerial: item.planSerial,
            //   uavSerial: item.uavSerial,
            //   uavModel: item.uavModel,
            //   pilot: item.pilot,
            //   type: item.type,
            //   status: item.status,
            //   airpointList: item.airpointList
            // }));
            this.taskList = records;
          } else {
            this.taskList = [];
          }
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            },
          });
        }
      });
    },
    handelOpenPlan(type){
      this.getRequest("/uav-task-server/airspace/getAirspaceUseGraph").then(res => {
        this.sendMessageToIframe(3, true);
        const data = res.data
        if (data.code === 0) {
          this.airSpacePlanData = data.data.data
          if(type !== 'update'){
            this.openPlan = true;
          }
        }
      })
    },
    close() {
      this.flyArea=false
    },
    closePlanTime(){
      this.sendMessageToIframe(3, false);
      this.openPlan = false;
      this.timeAirspaceIds = []
      this.sliderValue = 0
      this.currentTime = '00:00:00'
    },
    // 格式化时间的函数
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
      const minutes = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
      const secs = (seconds % 60).toString().padStart(2, '0');
      return `${hours}:${minutes}:${secs}`;
    },
    // 格式化滑块 tooltip 的函数
    formatTooltip(value) {
      return this.formatTime(value);
    },
    // 滑块值改变时的处理函数
    handleChange(value) {
      let _this= this;
      this.currentTime = this.formatTime(value);
      let date = timestampToTime(new Date()).split(' ')[0] + ' '+this.currentTime
      this.getRequest("/uav-task-server/airspace/getAirspaceByTimeFOrGraph?time="+date).then(res => {
        const data = res.data
        if (data.code === 0) {
          this.timeAirspaceIds = data.data
          _this.sendMessageToIframe(2, data.data)
        }else {
          this.$message.error({
            message: data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })

    },
    sendMessageToIframe(code , data){
      let message = {code:code, data:data};
      let iframe = document.getElementById('mapframe');
      if (iframe.contentWindow) {
        // 发送消息到iframe
        iframe.contentWindow.postMessage(message, '*'); // 注意目标来源地址
      }
    },
    handelHeightSlider(v){
      this.getRequest(`/uav-task-server/airspace/queryAirspace?all=all&bottomHeight=${this.value[0]}&topHeight=${this.value[1]}`)
        .then(res => {
          let _this = this
          let oData = res.data;
          let resObj = JSON.parse(oData.data);
          console.log(resObj)
          let ids= [];
          for (let obj of resObj.features){
            ids.push(obj.properties.id);
          }
          this.sendMessageToIframe(4, ids);
        })
      //this.sendMessageToIframe(4, this.value);
    },
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}


#dashboardIndex {
  z-index: 3;
  width: 100%;
  height: 100%;
  position: relative;
}
/* 两侧以及底部顶部z-index 为4  header为3 高于地图 */
.mapWrap{

  z-index: 2;
  position: absolute;
  top:73px;
  left:0;
  width: 100%;
  height: calc(100% - 73px);
  overflow: hidden;
}
.headerContent{
  pointer-events:none;
  z-index: 3;
  width: 100%;
  background-size: 100%;
  display: flex;
  justify-content: end;
  padding: 16px 22px 0 17px;
//position: relative;
  position: absolute;
}
@media screen and (max-width: 1920px) {
  .headerContent{
    height: 144px;
    background-image: url("../../assets/img/dashboard/header.png");
  }
  .headerMiddle{
    font-size: 66px;
    line-height: 60px;
  }
}
@media screen and (min-width: 2000px) {
  .headerContent{
    height: 240px;
    background-image: url("../../assets/img/dashboard/header_2880.png");
  }
  .headerMiddle{
    line-height: 100px;
    font-size: 100px;
  }
}
.headerLeft{
  position: absolute;
  left: 17px;
  top: 16px;
  z-index: 5;
  display: flex;
}
.headerBtn{
  width: 120px;
  height: 40px;
  background-image: url("../../assets/img/dashboard/menu_btn.png");
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  text-shadow: 2px 2px 2px 2px rgba(0,0,0,0.18);
  line-height: 40px;
  cursor: pointer;
}
.headerMiddle{
//width: 1388px;
  position: absolute;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 2.64px;
  text-shadow: 2px 3.46px 3.68px 0.32px rgba(16,9,0,0.50);
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.headerRight{
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #f0f0f0;
  letter-spacing: 1.4px;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 10px;
}

.contentWrap{
  position: absolute;
  top: 72px;
  height: calc(100% - 72px);
  width: 100%;
}
.leftContent{
  top: 0;
  left: 0;

}
.rightContent{
  top: 0;
  right: 0;
}
.leftContent,
.rightContent{
  z-index: 4;
  background: rgba(16,10,1,0.78);
  height: 100%;
//width: 20%;
  min-width: 400px;
  position: absolute;
  display: flex;
  flex-direction: column;
//overflow: auto;
}

.rightContent{
  right: 0;

}
.bottomContent{
  z-index: 4;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  width: calc(100% - 800px);
  justify-content: space-around;
}
.bottomBtn,.bottomBtnClick{
  cursor: pointer;
  text-align: center;
  line-height: 74px;
  width: 233px;
  height: 74px;
  font-size: 32px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 1.6px;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
}
.bottomBtn{
  background-image: url("../../assets/img/dashboard/normal.png");
}
.bottomBtnClick{
  background-image: url("../../assets/img/dashboard/click.png");
}
.contentItem{
  height: 66%;
  min-height: 325px;
  display: flex;
  flex-direction: column;
}
.contentItem10{
  height: 33%;
//min-height: 100px;
  display: flex;
  flex-direction: column;
}
.contentItem30{
  flex: 30;
  max-height: 26%;
  display: flex;
  flex-direction: column;
}
.itemTitle{
  height: 50px;
  background-image: url("../../assets/img/dashboard/pop_header.png");
  background-size: 100%;
  padding-left: 44px;
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35,21,0,0.48);
  margin-top: 12px;
}
.barChart,.lineChart{
  flex: 1;
  margin-top: 11px;
}
.inspectionContentWrap{
  padding: 23px 21px 0 29px;
  height: calc(100% - 50px);
}
#patrolHistory{
  background-image: url('../../assets/img/dashboard/shuju_bg2.png');
  width: 350px;
  height: 92px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
}
#patrolHistory .historyItem{
  width: 110px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 15px 0 15px;
}
#patrolHistory .historyItem:not(:last-child){
  border-right: 2px solid;
  border-image: linear-gradient(0deg, rgba(238,175,84,0.00), rgba(255,200,119,0.99) 49%, rgba(255,200,119,0.00)) 2 2;

}
#patrolDefect{
  padding: 13px 23px 23px 34px;
  width: 350px;
  height: 92px;
  display: flex;
  justify-content: center;
  background-image: url('../../assets/img/dashboard/shuju_bg.png');
}
#patrolDefect .dayItem{
  width: 120px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 0 15px 0 15px;
}
.data{
//margin-bottom: 5px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ebebeb;
}
.text{
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.checkData{
  border-bottom: 2px solid ;
  border-image: linear-gradient(0deg, rgba(255, 200, 119, 0.99), rgba(255, 200, 119, 0.00) 49%, rgba(238, 175, 84, 0.00)) 2 2;
  font-size: 30px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  margin-bottom: 8px;
}
.separate{
  border-right: 2px solid;
  border-image: linear-gradient(0deg, rgba(238,175,84,0.00), rgba(255,200,119,0.99) 49%, rgba(255,200,119,0.00)) 2 2;
}
.alarmWrap{
  height: calc(100% - 50px);
  padding: 0 33px 23px 27px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.alarmContentWrap{
  display: flex;
  justify-content: space-between;
}
.alertItem{
  background-size: 100%;
  position: relative;
  width: 140px;
  height: 132px;
}
.alertItemText{
  position: absolute;
  font-size: 18px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #ffffff;
  bottom: 6px;
  left: 34px;
}
.alertItemFigure{
  height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1px 1.73px 5px 2px rgba(20,10,0,0.68);
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
}
#heiFeiItem{
  background-image: url("../../assets/img/dashboard/hei_fei.png");
}
#chongTuItem{
  background-image: url("../../assets/img/dashboard/chong_tu.png");
}
#pianHangItem{
  background-image: url("../../assets/img/dashboard/pian_hang.png");
}
#zhengChangItem{
  background-image: url("../../assets/img/dashboard/zheng_chang.png");
}
.basic{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 50px);
  padding: 30px 34px 27px 24px;
}
.equipment{
  display: flex;
}
.up{
  background-image: url(../.././assets/img/dashboard/tubiao_chengse.png);
  background-position: top left;
  background-repeat: no-repeat;
  height: 98px;
  width: 98px;
  margin-right: 60px;
  position: relative;
}
.watch{
  background-image: url(../.././assets/img/dashboard/tubiao_jinse.png);
  background-position: top left;
  background-repeat: no-repeat;
  height: 98px;
  width: 98px;
  position: relative;
}
.datas{
  position: absolute;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
//text-align: left;
  color: #ffffff;
//z-index: 99;
  left: 57px;
  top: 10px;
}
.equipment .texts{
  min-width: 130px;
  position: absolute;
  left: 58px;
  top: 40px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
//text-align: left;
  color: #ebebeb;
//z-index: 99;
}
.states{
  display: flex;
}
.states .texts{
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.down{
  width: 159px;
  height: 132px;
  background: rgba(23,11,1,0.50);
  border: 2px solid rgba(255,200,119,0.30);
  margin-top: 5px;
}
.stateone{
  display: flex;
  margin-top: 12px;
}
.txt{
  width: 100%;
  height: 42%;
  font-size: 18px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ffffff;
  padding-left: 11px;
  padding-top: 15px;
}
.numbers{
  width: 45px;
  height: 17px;
  line-height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  margin-left: 45px;
}
.numberstwo{
  width: 20px;
  height: 17px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ff5555;
  margin-left: 45px;
}
.fa-mouse-pointer {
  cursor: pointer;
}
.lineChartWrap{
  flex:1;
  height: calc(100% - 92px);
}
.linkBtn{
  position: relative;
}
.linksGroup{
  position: absolute;
  left: 35px;
  top:-60px;
  width: 170px;
  height: 55px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.linksGroup a{
  line-height: 22px;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  font-size: 24px;
  font-family: 'PangMenZhengDao-3', 'PangMenZhengDao-3-Regular';
  font-weight: 400;
  text-decoration: underline;
  text-align: left;
  color: #ffc877;
}
.taskcontent_2d{
  padding: 5px 10px;
  height: 100%;
  overflow: auto;
}
.taskSearchBox{
  margin-bottom: 12px;
}

.taskSearchBox >>>input{
  box-sizing: border-box;
  width: calc(100% - 5px);
  height: 32px;
  background: rgba(23,11,1,0.50);
  border-radius: 6px;
  font-size: 14px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.taskSearchBox  /deep/.el-input__icon{
  height: 32px;
//border: 1px solid red;
  right: 10px;
  line-height: 38px;
  cursor: pointer;

}
.taskSearchBox input{

}
.taskSearchBox input >>>i{
//border: 1px solid red;
  position: absolute;
  top: 7px;
  bottom: 7px;
  right: 32px;
}
.task-item_2d {
  margin: 0 5px 6px 5px;
  cursor: pointer;
  width: calc(100% - 14px);
}
.task-item_2d .common{
  height: 38px;
  border-radius: 6px;
  color: #FFFFFF;
  display: flex;
  background: green;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}
.common .firstSpan{
  min-width: 90px;
}
.common .secondSpan{
  min-width: 50px;
}
.common .thirdSpan{
  min-width: 40px;
}
.task-item_2d  .donePlan{
  background: #220c03;
}
.task-item_2d  .prePlan{
  background: #2d0a0a;
}
.task-item_2d  .executePlan{
  background: #2f1d0b;
}
.prePlan:hover{
  box-shadow: 0px 0px 6px 1px #ff5555 inset;
}
.executePlan:hover{
  box-shadow: 0px 0px 6px 1px #ffc877 inset;
}
.donePlan:hover{
  box-shadow: 0px 0px 6px 1px deepskyblue inset;
}
.task-item_2d .planeBtns{
  padding-right: 5px;
  display: flex;
}
.emptyContent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 45px);
  flex: 1;
  width: 100%;
  background: #170b01;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
}
.planeBtns .planTobtn{
  display: flex;
  align-items: center;
  position: relative;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  cursor: pointer;
  z-index: 1001;
}
.planeBtns .planTobtn:not(:last-child){
  margin-right: 6px;
}
.planTobtn img{
  width: 26px;
  height: 26px;
}
.planeBtns .planTobtn span {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 35px;
  background-color: #333;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  z-index: 100;
}
.planeBtns .planTobtn:hover span {
  display: block;
}
.listAll_2d{
  height: calc(100% - 44px);
  width: 100%;
  overflow: auto;
}
#rightOverlay {
  width: 400px !important;
}
*{
  user-select: none;
}
.flyTop {
  padding: 13px 23px 23px 34px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px 22px 18px 22px;
  width: 350px;
  height: 92px;
  /* background-image: url("../../assets/img/2dmap/shuju_bg.png"); */
  background-image: url('../../assets/img/dashboard/shuju_bg.png');
}

.flyTopTop div:nth-child(1) {
  font-size: 30px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffc877;
  text-align: left;
}

.flyTopTop div:nth-child(2) {
  width: 100px;
  height: 15px;
}
.fa-mouse-pointer {
  cursor: pointer;
}
.canChangeFigure {
  height: 40px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;

}
.flyTop .flyText {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
#fenge {
  display: block;
  width: 70px;
  height: 0;
  border: 2px solid;
  border-image: linear-gradient(0deg, rgba(238, 175, 84, 0.00), rgba(255, 200, 119, 0.99) 49%, rgba(255, 200, 119, 0.00)) 2 2;
}
.flyTop .unActiveFigure {
  margin-top: 4px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: center;
  color: #ebebeb;
  margin-bottom: 11px;
}
.flyTop .erectFenge {
  width: 0px;
  height: 74px;
  border: 2px solid;
  border-image: linear-gradient(0deg, rgba(238, 175, 84, 0.00), rgba(255, 200, 119, 0.99) 49%, rgba(255, 200, 119, 0.00)) 2 2;
}
.RightBottomBottom {
  width: 306px;
  height: 38px;
  /* background: rgba(23, 11, 1, 0.50); */
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  background-image: url(../../../src/assets/img/2dmap/paihang_bg.png);
}
.shortShuFenge {
  margin-left: 2px;
  width: 4px;
  height: 28px;
  margin-right: 6px;
}
.rightBottomBottomText {
  width: 100px;
  height: 16px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.processStyle {
  width: 155px;
  height: 6px;
  margin-right: 10px;
  margin-left: 10px;
}
.RightBottomBottomFigure {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}
.titleShuFenge {
  margin-left: 2px;
  width: 4px;
  height: 38px;
  margin-right: 6px;
}
.inspectionContentWrap .rightBottomTop .titleBgL {
  background: linear-gradient(90deg, rgba(255, 140, 77, 0.50) 0%, rgba(255, 140, 77, 0.00) 100%);
}

.inspectionContentWrap .rightBottomTop .titleBgR {
  background: linear-gradient(90deg, rgba(255, 85, 85, 0.50) 0%, rgba(255, 85, 85, 0.00) 100%);
}
.inspectionContentWrap .rightBottomTop .titleBgL,
.inspectionContentWrap .rightBottomTop .titleBgR {
  width: 140px;
  height: 38px;
  display: flex;
  align-items: center;
}
.ordinaryText {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
  margin-right: 10px;
}
.contentFigure {
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
}
.ordinaryFigure {
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ebebeb;
}
.openLeftBtn{
  cursor: pointer;
  position: absolute;
  left: 5px;
  top:8px;
}
.closeLeftBtn{
  cursor: pointer;
  position: absolute;
  right: -35px;
  top:8px;
}

.openPlan {
  cursor: pointer;
  position: absolute;
//bottom: 8px;
  top: 154px;
  left: 8px;
  width: 38px;
  height: 38px;
  z-index: 1000;
}

.leftPlan {
  background: rgba(23, 11, 1, 0.90);
  overflow: auto;
  display: flex;
  display: -webkit-flex;
  height: calc(100% - 165px);
  padding: 10px;
  flex-direction: column;
  width: 900px;
  z-index: 1000;
  position: absolute;
  top: 102px;
  left: 14px;
}
.leftPlan .itemTitle {
  height: 50px;
  background-image: url("../../assets/img/2dmap/pop_header_long.png");
  background-size: 100%;
  padding-left: 20px;
  width: 100%;
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35, 21, 0, 0.48);
  margin: 12px 0 12px 0;
}

.closePlan {
  z-index: 1003;
  cursor: pointer;
  position: absolute;
  left: 920px;
  top: 102px;
  width: 38px;
  height: 38px;
}
.airspaceTitle {
  background-image: url("../../assets/img/2dmap/kong_yu_guan_li.png");
  background-repeat: no-repeat;
  height: 50px;
  text-align: left;
  padding-left: 27px;
  background-size: 80% 38px;
  width: 100%;
}

.airspaceTitle span{
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: 400;
  text-align: left;
  font-family: PangMenZhengDao, PangMenZhengDao-3;
  text-shadow: -2px 0px 3.68px 0.16px rgba(16, 1, 0, 0.50);
  color: #ffffff;
}

#chooseAirspace .close {
  cursor: pointer;
  position: absolute;
//right: -30px;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  width: 38px;
  height: 38px;
  //background: rgba(15, 86, 115, 0.4);
}

>>> .positionSet {
  position: relative;
  z-index: 9999;
}

.coordinateRow {
  display: flex;
  flex-wrap: wrap;
}

#chooseAirspace {
  position: absolute;
  bottom: 8px;
//left: 800px;
  right: 50px;
  min-width: 240px;
  width: 48%;
//height: 20%;
  z-index: 1004;
  background: rgba(23, 11, 1, 0.50);
  border-radius: 6px;
  padding: 10px 30px 10px 10px;
//background-image: url("../../assets/img/2dmap/bac3.png");
  background-size: 100% 100%;
  opacity: 0.9;
}

>>> .coordinateRow .el-input__suffix {
  right: 14px;
}

>>> .coordinateRow .el-input__inner {
  padding-right: 0px;
}
.coordinateRow .el-button {
  width: 20px;
}
.coordinate {
  width: 48%;
}

.coordinate:nth-of-type(odd) {
  margin-right: 4%;
}
.select .el-select {
  width: 100% !important;
}

.select .el-select .el-input__inner {
  color: #fff;
  height: 30px;
  background: rgba(23, 11, 1, 0.50);

}

.select .el-select .el-input__suffix {
  right: 10px;
}

>>> .el-form .el-form-item__label {
  font-family: Source Han Sans CN;
  font-size: 14px;
  color: #ffffff;
  line-height: 40px;
}

>>> .el-input__inner {
  /* border: 1px solid #1D6DC8; */
  /* background-color: #153862; */
  border: unset !important;
  background: rgba(10, 5, 0, 0.50);
  border-radius: 6px;
  color: #fff;
  height: 32px;
  cursor: not-allowed;
}

.coordinate >>> .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
  border: none;
  background-color: transparent
}
>>> .el-input.is-disabled .el-input__inner{
  background-color:rgba(10, 5, 0, 0.50);
  border-color:#E4E7ED;
  color:#C0C4CC;
  cursor:not-allowed
}

>>> .el-textarea.is-disabled .el-textarea__inner {
  background-color: rgba(10,5,0,.5)!important;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}

.timeSlider{
  color: #FFFFFF;
  //margin: 10px 20px;
  //position: fixed;
  top:145px;
  width: 740px;
  margin-left: 120px;
}
.timeListWrap{
  height: calc(100% - 70px);
  overflow: auto;
}
>>>.timeSlider .el-slider__bar {
  background-color: #fee075;
  border-color: #c49100;
}
>>>.timeSlider .el-slider__button  {
  border-color: #fee075;
}
.heightSliderWrap{
  position: absolute;
  top: 220px;
  background: rgba(23, 11, 1, 0.50);
  height: calc(100% - 235px);
  width: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  z-index: 1000;
  border-radius: 5px;
  margin-left: 5px;
}
.spanClass{
  z-index: 1050;
  color: deepskyblue;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  font-size: 14px;
}
.heightSlider{
  width: 80px;
  display: block;
//position: absolute;
//top: 250px;
  /* height: calc(100% - 270px); */
  height: 90%;
//width: 50px;
}

>>> .heightSlider .el-slider__marks-text {
  color: white;
  width: 50px;
  text-align: left;
}
>>>.heightSlider .el-slider__bar{
  background-color: #fee075;
  border-color: #c49100;
}
>>>.heightSlider .el-slider__button{
  border-color: #fee075;
}
>>>#chooseAirspace .el-date-editor{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/ThreedSpaceControll.vue